import React from "react";
//import {Modal,Card,CardBody,Col,Button} from "reactstrap";
import Chart from 'react-apexcharts'
import reduxHelper from "./../../../helper/index.js";
import { connect } from 'react-redux';
import moment from 'moment';
import api from "../../../Api.js";
//import MultiSelect from "@khanacademy/react-multi-select";
//import Desempenho_no_quiz from './../chartlist/Desempenho_quiz.jsx';
 

class ModalBasicChartUser extends React.Component { 

	constructor(props){
        super(props);
        this.setStateTop = this.props.setState;
        this.helper = new reduxHelper(this.props);
        this.getDataChart2 = this.getDataChart2.bind(this);

        this.downloadFullHistoryCSV = this.downloadFullHistoryCSV.bind(this);

        this.state = {
            series2: [],
            label2: [],
            idUser: this.props.idUser
        };

        window.chartuser = this;
    }
      
    async componentDidUpdate(){

        if(this.state.idUser !== this.props.idUser){

            await this.setState({idUser:this.props.idUser});
            //this.getDataChart1();
            this.getDataChart2();

        }

    }
 
    componentDidMount(){ this.getDataChart2(); }
  
    chart2(){

        return{
            stroke:{width:[0,4]}, 
            labels:this.state.label2,
            yaxis:[{title:{text: this.props.translate['tempo_em_minutos']}}]
        };

    }

    async getDataChart1(){

        var data = await this.helper.chart().chartQuizperFormance(this.props.idUser);

        if(data !== false){

            if(data.status === 200){

                this.setState({series1:data.data});
                console.log(data.data);
                return data.data;

            }

        }

        return [];
        
    }


    async getDataChart2(){

        var data = await this.helper.chart().chartTimeInvested(this.props.idUser);

        if(data !== false){

            if(data.status === 200){

                for(let index = 0; index < data.data.label.length; index++){

                    data.data.label[index] = moment(data.data.label[index],'YYYY-MM-DD').format('DD/MM/YYYY')
                    
                }

                var series2 = [{
                    name: this.props.translate['em_aula'],
                    type: 'column',
                    data: data.data.minutes
                }];
                
                this.setState({label2:data.data.label,series2:series2,load:true});
                return data.data;

            } 
        }  
    }

    async downloadFullHistoryCSV(){
        try {
            const response = await api.chartFullDaysCSV(this.props.idUser);
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `historico_completo_${this.props.idUser}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            alert('Erro ao baixar CSV completo');
        }
    }

  	render() {
        const { label2, series2, load } = this.state;
        const height = this.props.height === undefined ? "" : this.props.height;
        const width = this.props.width === undefined ? "100%" : this.props.width;

        return (
            <React.Fragment>
                <div 
                    className="alert alert-secondary p-2 mb-3 d-flex justify-content-between align-items-center"
                    style={{ fontSize: '0.75rem', color: '#666', backgroundColor: '#f8f9fa' }}
                >
                    <div>
                        <i className="fas fa-info-circle mr-2"></i>
                        Exibe dados dos últimos 10 dias.
                    </div>
                    <button 
                        className="btn btn-sm btn-secondary" 
                        onClick={this.downloadFullHistoryCSV}
                    >
                        <i className="fas fa-download mr-1"></i>
                        Baixar Histórico Completo
                    </button>
                </div>

                {load && (
                    <Chart 
                        options={this.chart2()} 
                        series={series2} 
                        height={height} 
                        type="bar" 
                        width={width} 
                    />
                )}
            </React.Fragment>
        );
    }
}


export default connect(state =>({

	languages: state.language,
	translate: state.translate,
	accesslevel: state.accesslevel,
	permission: state.permission,
	user: state.user,
  
}))(ModalBasicChartUser);